import $ from 'jquery';

// Private function

class VimeoPlayer {
	constructor() {
		this.initialized = false;
		this.player = null;
		this.vidID = null;
		this.dur = null;
		this.state = -1; // -1: unstarted, 0: ended, 1: playing, 2: paused, 3: buffering, 5: video cued.
		this.midTracked = null;
		this.timeout = null;
		this.initialPlayed = false;
		this.playerReady = false;
		this.trackID = null;
		this.playstate = "none";
		this.events = {
			start: [],
			midpoint: [],
			end: [],
			pause: [],
			resume: []
		};
		return this;
	}

	dispatchEvent(eventID, scope) {
		var self = scope || this;
		if (self.events[eventID]) {
			for (var i = self.events[eventID].length - 1; i >= 0; i--) {
				try {
					self.events[eventID][i].call(null, self.vidID);
				} catch (er) {
					console.warn(er.message);
				}
			}
		}
	}

	static get defaultPlayerVars() {

		if (!this._defaultPlayerVars) {
			// PlayerVars documentation: https://developer.vimeo.com/player/sdk/embed
			// additional documentation: https://vimeo.zendesk.com/hc/en-us/articles/360001494447-Using-Player-Parameters
			this._defaultPlayerVars = {
				autopause: true, // pause a video when another video starts to play
				autoplay: false, // start playback automatically
				background: false, // background mode ['Vimeo Plus account or higher']
				byline: false, // display video owner's name ['if video owner allows']
				color: '#00ADEF', // hex color value of playback controls ['Vimeo Plus account or higher']
				controls: true, // show controls or show chromeless experience [requires custom js controls] ['Vimeo Plus account or higher']
				dnt: false, // prevent tracking data - also blocks video stats
				// height: 'None', // height of video in pixels
				loop: false, // automatically restart video when it finishes
				// maxheight: 'None', // hieght of video in pixels, video wont exceed native height
				// maxwidth: 'None', /// width of video in pixels, video wont exceed navite width
				muted: false, // video is muted upon loading
				pip: false, // picture-in-picture button in controls
				playsinline: true, // plays inline on supported mobile devices
				portrait: false, // display video owner's portrait ['if video owner allows']
				quality: 'auto', // playback quality of video ['Vimeo Plus account or higher']
				responsive: false, // returns a responsive embed code but we already have it set up that way
				speed: false, // display speed controls ['PRO account or higher']
				// texttrack: 'None', // text track to display with video.  Requires text track to exist
				title: true, // Display title overlay ['if video owner allows']
				transparent: true, // whether responsive player and transparent background are enabled
				// width: 'None', // width of video in pixels
			};
		}
		return this._defaultPlayerVars;
	}

	/**
	 * Create a new Vimeo Player instance.
	 */
	initPlayer(elID, videoUrl, playerVars) {
		// default playervars to empty Object
		playerVars = (playerVars) ? playerVars : {};
		playerVars = $.extend({ url: videoUrl }, VimeoPlayer.defaultPlayerVars, playerVars);
		this.videoUrl = videoUrl;
		// update the player if it exists - unless playerVars.forceNew exists
		if (this.player && (!playerVars.hasOwnProperty('forceNew') || playerVars.forceNew !== true)) {
			//console.log('[VimeoPlayer].loadVideo');
			this.player.loadVideo(videoUrl);
		} else {
			//console.log('[VimeoPlayer].create new Vimeo');
			this.player = new window.Vimeo.Player(elID, playerVars);
		}
		//console.log('[VimeoPlayer].player: ', this.player);
	}

	cueVideo(ytID, scope) {
		scope.vidID = ytID;
		if (scope.playerReady) {
			//player is ready.  Cue the video.
			scope.player.cueVideoById(ytID);
		}
	}

	playVideo() {
		this.player.play();
	}

	pauseVideo() {
		this.player.pause();
	}

	checkForMidpoint(scope) {
		//get video duration
		if (!this.dur || this.dur === 0) {
			this.dur = scope.player.getDuration();
			//don't check until a duration is available.
			if (!this.dur || this.dur === 0) {
				return;
			}
		}
		var curTime = this.player.getCurrentTime();
		if (curTime > this.dur / 2) {
			this.midTracked = true;
			VimeoPlayer.dispatchEvent('midpoint', this);
			clearInterval(this.timeout);
		}
	}

	replayVideo() {
		if (this.playerReady) {
			this.player.seekTo(0, true);
		}
	}

	addEventListener(eventID, cb) {
		if (this.events[eventID]) {
			this.events[eventID].push(cb);
		}
	}

	removeEventListener(eventID, cb) {
		if (this.events[eventID]) {
			var tIndex = this.events[eventID].indexOf(cb);
			if (tIndex >= 0) {
				this.events[eventID].splice(tIndex, 1);
			}
		}
	}

	destroy() {
		this.player.destroy();
	}

	static extractIdFromUrl(url) {
		//console.log('[VimeoPlayer].extractIdFromUrl()', url);
		//this Regex will split out the url into the [protocol/subdomain/vimeoplayer.com] block and the [id] block.
		var exp = /(?:http[s]?:\/\/)(?:www\.|player\.)?vimeo\.com\/(?:event\/|channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/,
			res = exp.exec(url);
		//console.log('[VimeoPlayer].extractIdFromUrl()::res: ', res);
		if (res && res.length === 2) {
			return res[1];
		} else {
			return "";
		}
	}
}

export default VimeoPlayer;